import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { IServerResponse } from 'src/app/model/add-view-call-flow.model';
import { ICheckListModel, IGetCheckListModel } from 'src/app/model/checkList.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CheckListService {
  // todo need to figure out why triggerGetChekListLogMethod has been added
  public triggerGetChekListLogMethod = new Subject();

  constructor(private httpClient: HttpClient) { }

  addCheckList(checkListModel: ICheckListModel): Observable<IServerResponse> {
    const url = `${environment.apiHost}/CallFlowAndCheckList/SaveCheckList`;

    return this.httpClient
      .post<IServerResponse>(url, checkListModel)
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  getCheckListDetails(serviceType: string, currentBusinessUnitId: string): Observable<IServerResponse> {
    const url = `${environment.apiHost}/CallFlowAndCheckList/CheckList/${serviceType}/${currentBusinessUnitId}`;

    return this.httpClient
      .get<IServerResponse>(url)
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  getCheckListBySR(getCheckListModel: IGetCheckListModel, updateCheckListItems, lastUpdatedById: string): Observable<IServerResponse> {
    const url = `${environment.apiHost}/CallFlowAndCheckList/CheckList/${getCheckListModel.serviceType}/${getCheckListModel.memberId}/${getCheckListModel.serviceRequestId}/${lastUpdatedById}`;

    return this.httpClient
      .post<IServerResponse>(url, updateCheckListItems)
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  getCheckListLogs(serviceRequestId: string): Observable<IServerResponse> {
    const url = `${environment.apiHost}/CallFlowAndCheckList/CheckListLog/${serviceRequestId}`;

    return this.httpClient
      .get<IServerResponse>(url)
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }
}
